import getConfig from 'next/config'

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

const Constants = {
  ...publicRuntimeConfig,
  ...serverRuntimeConfig,
}

export default Constants
